<template>
  <div id="app-index">
    <about-head></about-head>
    <pub-nav></pub-nav>
    <div class="councli-nav">
      <div class="nav-top">
        <div class="top-box">
          <h3>关于我们</h3>
          <p>About us</p>
        </div>
      </div>
      <div class="seat-box">
          <h3>
            您的位置：首页 > 关于我们 >
            <span>理事会成员</span>
          </h3>
          <div :class="{'border-box':classShow, 'animated': classHide, 'fadeInUpBig': classHide}"></div>
        </div>
      <div class="nav-bottom">
        <div class="list-box">
          <div class="list-l">
            <img src="../../assets/images/council.png" alt>
            <div class="info-box">
              <h5>
                <span>{{data.name}}</span>
                <i>先生</i> 理事长
              </h5>
              <ul>
                <li v-for="(item,index) in data.deedList" :key="index">{{item.title}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <about-foot></about-foot>
  </div>
</template>
<script>
import animate from "animate.css";
import aboutHead from "../Public/head";
import pubNav from "../Public/nav";
import aboutFoot from "../Public/foot";

export default {
  components: {
    aboutHead,
    pubNav,
    aboutFoot
  },
  data() {
    return {
      classShow: true,
      classHide: false,
      data: {
        name: "张跃文",
        deedList: [
          {
            id: 1,
            title: "- 第九届中国设计业青年百人榜获奖者并颁发证书"
          },
          {
            id: 1,
            title: "-  Adobe TOP领航者之一  并颁发证书"
          },
          {
            id: 1,
            title: "-  作品收录意大利全国工业设计协会丛书中"
          },
          {
            id: 1,
            title: "-  作品收录意大利全国工业设计协会丛书中,作品收录意大利全国工业设计协会丛书中,作品收录意大利全国工业设计协会丛书中,作品收录意大利全国工业设计协会丛书中,作品收录意大利全国工业设计协会丛书中,作品收录意大利全国工业设计协会丛书中,"
          }
        ]
      }
    };
  }
};
</script>
<style lang="scss" scoped>
#app-index {
  width: 100%;
}
.councli-nav {
  width: 100%;
  .nav-top {
    width: 100%;
    height: 300px;
    background: url(../../assets/images/nav_bg.png) no-repeat;
    background-size: 100% 100%;
    .top-box {
      width: 1300px;
      margin: 0 auto;
      padding-top: 118px;
      > h3 {
        font-size: 36px;
        color: #333333;
        font-weight: normal;
      }
      > p {
        font-size: 26px;
        font-weight: normal;
        color: #999999;
      }
    }
  }
  .seat-box {
    width: 1300px;
      margin: 0 auto;
      > h3 {
        font-size: 14px;
        color: #999;
        text-align: right;
        font-weight: normal;
        padding: 28px 0 17px;
        > span {
          color: #333333;
        }
      }
      .border-box {
        width: 1300px;
        height: 1px;
        border: 1px solid #c30d23;
        border-bottom: 3px solid #c30d23;
      }
    }
  .nav-bottom {
    width: 1300px;
    margin: 0 auto;
    margin-bottom: 80px;
    border: 1px solid #eee;
    .list-box {
      padding: 15px 17px;
      margin-bottom: 52px;
      display: flex;
      justify-content: space-between;
      transition: ease-in 0.6s;
      .list-l {
        display: flex;
        > img {
          width: 450px;
          height: 338px;
          margin-right: 58px;
        }
        .info-box {
          width: 758px;
          > h5 {
            font-size: 16px;
            color: #999999;
            font-weight: normal;
            > span {
              font-size: 24px;
              color: #333;
              font-weight: 700;
              padding-right: 5px;
            }
            > i {
              font-style: normal;
              font-size: 16px;
              color: #999999;
              padding-right: 20px;
            }
          }
          > ul {
            margin-top: 39px;
            > li {
              list-style: none;
              font-size: 14px;
              color: #333333;
              margin-bottom: 12px;
              line-height: 26px;
            }
          }
        }
      }
      .list-r {
        width: 61px;
        margin: 70px 0;
        border-left: 1px solid #eee;
        > h5 {
          font-size: 14px;
          color: #333;
          font-weight: normal;
          text-align: center;
          padding-top: 13px;
        }
        > p {
          font-size: 14px;
          color: #333;
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Council/council_details.vue